var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditBase } from "react-admin";
import { CandidateDataForm } from "./CandidateDataForm";
export var EditCandidateData = function (_a) {
    var record = _a.record;
    var transform = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        console.log("TRANSFORM ELECTION :: ", data);
        // save presentation object
        // language_conf
        console.log("data before :: ", data);
        var enabled_language_codes = [];
        for (var key in data.enabled_languages) {
            if (typeof data.enabled_languages[key] === "boolean" && data.enabled_languages[key]) {
                enabled_language_codes.push(key);
            }
        }
        var language_conf = {
            enabled_language_codes: enabled_language_codes,
        };
        // i18n
        // is alll object, no change needed
        delete data.enabled_languages;
        // name, alias and description fields
        var fromPresentationName = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.presentation) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.en) === null || _c === void 0 ? void 0 : _c.name) ||
            ((_d = data === null || data === void 0 ? void 0 : data.presentation) === null || _d === void 0 ? void 0 : _d.i18n[Object.keys(data.presentation.i18n)[0]].name) ||
            "";
        data.name = fromPresentationName;
        var fromPresentationAlias = ((_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.presentation) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f.en) === null || _g === void 0 ? void 0 : _g.alias) ||
            ((_h = data === null || data === void 0 ? void 0 : data.presentation) === null || _h === void 0 ? void 0 : _h.i18n[Object.keys(data.presentation.i18n)[0]].alias) ||
            "";
        data.alias = fromPresentationAlias;
        var fromPresentationDescription = ((_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.presentation) === null || _j === void 0 ? void 0 : _j.i18n) === null || _k === void 0 ? void 0 : _k.en) === null || _l === void 0 ? void 0 : _l.description) ||
            ((_m = data === null || data === void 0 ? void 0 : data.presentation) === null || _m === void 0 ? void 0 : _m.i18n[Object.keys(data.presentation.i18n)[0]].description) ||
            "";
        data.description = fromPresentationDescription;
        // END name, alias and description fields
        return __assign(__assign({}, data), { presentation: __assign(__assign({}, data.presentation), { language_conf: __assign(__assign({}, language_conf), { default_language_code: data.defaultLanguage }) }) });
    };
    return (_jsx(EditBase, __assign({ redirect: ".", transform: transform }, { children: _jsx(CandidateDataForm, { record: record }) })));
};
